import React from 'react';
import Section from '../ui/Section.jsx';
import Avatar from '../ui/Avatar.jsx';
import PersonLink from '../ui/PersonLink.jsx';
import Skeleton from '../ui/Skeleton.jsx';
import Pagination, { usePagination } from '../ui/Pagination.jsx';
import { fmtHours } from '../../utils/formatters.js';

export default function TeamLists({ project, loadingRedmine = false, redmineError = false }) {
  const active = project.active_team || [];
  const { pageItems, ...pager } = usePagination(active, 20);

  if (loadingRedmine) {
    return (
      <Section id="team" title="Team" count="Loading…">
        <ul className="divide-y" style={{ borderColor: '#F0EFE9' }}>
          {[0, 1, 2, 3].map((i) => (
            <li key={i} className="flex items-center gap-3 py-2.5">
              <Skeleton width={28} height={28} radius={999} />
              <span className="flex-1"><Skeleton width="40%" height={13} /></span>
              <Skeleton width={40} height={12} />
            </li>
          ))}
        </ul>
      </Section>
    );
  }

  if (redmineError) {
    return (
      <Section id="team" title="Team" count="—">
        <div className="text-[12px]" style={{ color: '#9A9A95' }}>Live team data unavailable.</div>
      </Section>
    );
  }

  return (
    <Section id="team" title="Team" count={`${active.length} active`}>
      {active.length === 0 ? (
        <div className="text-[12px]" style={{ color: '#9A9A95' }}>No members in Redmine.</div>
      ) : (
        <>
          <ul className="divide-y" style={{ borderColor: '#F0EFE9' }}>
            {pageItems.map((m) => (
              <li key={m.id} className="flex items-center gap-3 py-2.5">
                <PersonLink redmineId={m.id} className="group flex flex-1 items-center gap-3 min-w-0">
                  <Avatar initials={m.initials} seed={m.name} />
                  <span className="flex-1 text-[13px] group-hover:underline"
                        style={{ color: '#1A1A1A' }}>{m.name}</span>
                </PersonLink>
                <span className="font-mono text-[12px]"
                      style={{ color: m.hours_mtd > 0 ? '#1A1A1A' : '#9A9A95' }}>
                  {fmtHours(m.hours_mtd)} h
                </span>
              </li>
            ))}
          </ul>
          <Pagination {...pager} />
        </>
      )}
    </Section>
  );
}
